var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotificationActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bell 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.38412 15.9844H17.4003C17.8009 15.9844 18.1956 15.888 18.551 15.7033C18.9064 15.5187 19.2121 15.2512 19.4422 14.9235C19.6722 14.5958 19.8199 14.2176 19.8727 13.8208C19.9256 13.424 19.882 13.0204 19.7456 12.644L17.3745 6.09371C16.9696 4.63803 16.0986 3.35496 14.8948 2.44072C13.6909 1.52649 12.2205 1.03143 10.7085 1.03125C9.13443 1.03123 7.60744 1.56756 6.37962 2.5517C5.1518 3.53584 4.29657 4.90893 3.95512 6.44428L2.00137 12.7578C1.88633 13.1306 1.86047 13.5251 1.92587 13.9097C1.99126 14.2942 2.14607 14.6581 2.37786 14.9719C2.60965 15.2858 2.91193 15.5409 3.26038 15.7168C3.60884 15.8926 3.99374 15.9843 4.38412 15.9844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.91797 17.6602C7.10917 18.5939 7.62002 19.4334 8.36396 20.0364C9.1079 20.6394 10.0392 20.9688 11 20.9688C11.9608 20.9688 12.8921 20.6394 13.636 20.0364C14.38 19.4334 14.8908 18.5939 15.082 17.6602H6.91797Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationActive);
export default __webpack_public_path__ + "static/media/icon_notification_active.8b13028ce575db0a00e6c9bc83190808.svg";
export { ForwardRef as ReactComponent };